// libs
import styled, { css } from 'styled-components'
// themes
import { colors } from 'themes'
// icons
import CommentIconOrigin from '@mui/icons-material/AddCircleOutline'
import DeleteIconOrigin from '@mui/icons-material/RemoveCircleOutline'
import EditIconOrigin from '@mui/icons-material/Edit'
// utils
import { size } from 'polished'

const ActivityActionsWrapper = styled.div`
  display: none;
  border: 1px solid darkcyan;
  border-radius: 25px;
  width: fit-content;
  position: absolute;
  right: 0;
  top: 0;

  div:last-child {
    border: none;
  }
`
const OptionWrapper = styled.div`
  color: ${colors.blue500};
  font-weight: 500;
  cursor: pointer;
  display: flex;
  padding: 4px;
  border-right: 1px solid ${colors.blue500};
  align-items: center;

  &:hover {
    opacity: 0.7;
  }
`

const iconStyles = css`
  ${size('16px')};

  path {
    fill: ${colors.blue500};
  }
`

const CommentIcon = styled(CommentIconOrigin)`
  && {
    ${iconStyles}
  }
`

const DeleteIcon = styled(DeleteIconOrigin)`
  && {
    ${iconStyles}
  }
`

const EditIcon = styled(EditIconOrigin)`
  && {
    ${iconStyles}
  }
`

export { ActivityActionsWrapper, OptionWrapper, CommentIcon, DeleteIcon, EditIcon }
